import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import BenefitsList from './BenefitsList';
import { Button } from './tailwind';

const benefits = ['Faster Checkout', 'Order Tracking', 'Order History', 'Address Book', 'New Product Alerts'];

const NewCustomer = () => {
  return (
    <div className='new-customer-widget'>
      <h4 className='new-customer-widget__title'>New Customer</h4>
      <div className='new-customer-widget__cta'>
        <Button
          variant='primary'
          fullWidth='all'
          href={jsRoutes.controllers.UserController.createAccount().url}>
          Create Account
        </Button>
      </div>
      <BenefitsList items={benefits} title='Account Benefits include:' />
    </div>
  );
};

export default memo(NewCustomer);
